import React from 'react';
import FileList from '../FileList/FileList'
import Loading from '../Loading'
import ShadowModal from '../ShadowModal'
import { GigFileTable } from './GigComponent'
import { getAllCollector } from '../../helpers/collectors'
import { observer } from "mobx-react-lite"
import AppState from '../../AppState';
import { File } from '../FileList/types';

interface Props {
    state: AppState
}

const EditGig = observer(({state}: Props) => {
    if (!state.gigToEdit) {
        return null
    }

    const contentLabel = state.gigToEdit.id ? "Muokkaa" : "Luo keikka"

    const handleChange = (e: { target: { name: any; value: any; }; }) => {
        state.setGigToEdit({...state.gigToEdit, [e.target.name]: e.target.value})
    }

    const editTableConfig = {
        id: 'editGig',
        title: 'Lisää nuotteja',
        collector: getAllCollector(),
        addAndRemove: true,
        searchEnabled: true,
    }

    return (
        <ShadowModal contentLabel={contentLabel} isOpen={!!state.gigToEdit} onRequestClose={() => state.setGigToEdit(null)} shouldCloseOnOverlayClick={true} >
            <div className="edit-modal gig-modal">
                <div className="flux-container">
                    <div className="left">
                        <div>
                            <input placeholder='Nimi' name="name" onChange={handleChange} value={state.gigToEdit.name ? state.gigToEdit.name : ''} />
                        </div>
                        <div>
                            <textarea placeholder='Kuvaus' name="description" rows={10} cols={40} onChange={handleChange} value={state.gigToEdit.description ? state.gigToEdit.description : ''} />
                        </div>
                        <div>
                            <input placeholder='Ajankohta' name="date" type="date" onChange={handleChange} value={state.gigToEdit.date ? state.gigToEdit.date : ''} />
                        </div>
                        <p className="modal-create-info-text"> &#11014; Keikat tulee tämän ajan mukaan järjestykseen ja katoavat näkyvistä kun asetettu aika on ohitettu</p>
                    </div>
                    <div className="right">
                        <h6>Keikan nuotit</h6>
                        <GigFileTable
                            gig={state.gigToEdit} config={state.config} removeFile={(file: File) => state.removeCurrentGigFile(file)}
                        ></GigFileTable>
                    </div>
                </div>
                <Loading loading={state.filesLoading}>
                    <FileList 
                        state={state} 
                        key={editTableConfig.id}
                        tableConfig={editTableConfig} />
                </Loading>
                <div className="floating-footer">
                    <button className="success" onClick={() => {state.handleGigUpdate(); state.setGigToEdit(null)}}>Save</button>
                    <button className="danger" onClick={() => {state.handleGigDelete(); state.setGigToEdit(null)}}>Delete</button>
                </div>
            </div>
        </ShadowModal>
    )
})

export default EditGig
